var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view == 'insumos')?_c('view-component',{attrs:{"models_to_show":_vm.insumos,"show_models_if_empty":"","model_name":"article"},on:{"modelSaved":_vm.insumo_saved}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }